export class FindAllOrganisationMembersError {
  public static readonly type =
    '[Organisation/OrganisationMembers/List] FindAllOrganisationMembersError';
  constructor(public readonly error: Error) {}
}
